import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { Box } from '../Box/Box'
import { FlexGrow } from '../layout/Flex'

const StyledBox = styled(Box)`
  @media (hover: hover) {
    &:has(label:hover) {
      label {
        border-radius: 0.9rem;
        margin: -${({ theme }) => theme.spacing.m};
        padding: ${({ theme }) => theme.spacing.m};
      }
    }
  }

  /* unchecked */
  background: ${({ theme }) => theme.arcadeColors.component.inputBackgroundDefault};
  border: 0.125rem solid ${({ theme }) => theme.arcadeColors.component.inputBorderDefault};

  /* checked */
  &:has(input:checked) {
    border: 0.125rem solid ${({ theme }) => theme.arcadeColors.component.inputBorderSelected};
  }

  /* active & not disabled */
  &:has(input:active):not(:has(input:disabled)) {
    label {
      border-radius: 0.9rem;
      margin: -${({ theme }) => theme.spacing.m};
      padding: ${({ theme }) => theme.spacing.m};
      background: ${({ theme }) => theme.arcadeColors.component.inputBackgroundPressed};
    }
  }

  /* focused */
  ${({ theme }) => theme.selectors.keyboard} &:has(input:focus) {
    border: 0.125rem solid ${({ theme }) => theme.arcadeColors.component.inputBorderFocus};
  }

  /* disabled */
  &:has(input:disabled) {
    border: 0.125rem solid ${({ theme }) => theme.arcadeColors.component.radioInactiveBorderDisabled};
  }
`
export type HelpTextProps = 'helpText' | 'HelpTextIcon' | 'errorText' | 'disabledText' | 'isInvalid'

export const InputCard = ({ children }: React.PropsWithChildren) => {
  const theme = useTheme()

  return (
    <FlexGrow>
      <StyledBox padding={`${theme.spacing.m} ${theme.spacing.m}`} borderRadius={theme.border.radius.medium}>
        {children}
      </StyledBox>
    </FlexGrow>
  )
}
